import { render, staticRenderFns } from "./FilePythonIcon.vue?vue&type=template&id=1546aecf&scoped=true&"
import script from "./FilePythonIcon.vue?vue&type=script&lang=js&"
export * from "./FilePythonIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1546aecf",
  null
  
)

export default component.exports